export default {
  name: "ChooseUserTypeComponent",
  components: {
    ChooseFormTypeComponent: require("../ChooseFormTypeComponent/ChooseFormTypeComponent.vue")
      .default,
  },
  data() {
    return {
      userTypes: [
        {
          name: "employee",
          displayedName: "Pracownicy",
          route: "ChooseFormTypeComponent"
        },
        {
          name: "polishStudent",
          displayedName: "Studenci i doktoranci",
          route: "ChooseFormTypeComponent",
        },
        {
          name: "foreignStudent",
          displayedName: "Foreign Students",
          route: "ChooseFormTypeComponent",
        },
      ],
      isSafari: "",
      redirectTo: "",
    };
  },
  methods: {
    checkBrowser() {
      if (
        navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1
      ) {
        this.isSafari = "is-safari";
      } else this.isSafari = "";
    },
  },
  created() {
    this.checkBrowser();
  },
};
